<template>
  <button
    class="flex flex-col justify-around h-8 w-8 p-1 rounded-sm hover:bg-gray-400"
  >
    <span class="h-0.5 rounded-sm bg-icon-primary w-full"></span>
    <span class="h-0.5 rounded-sm bg-icon-primary w-full"></span>
    <span class="h-0.5 rounded-sm bg-icon-primary w-full"></span>
  </button>
</template>
